<div class="onboarding-home-shell">
  @if (view() === 'dataset-select') {
    <lib-dataset-home (selectionComplete)="onDatasetSelection($event)" />
  } @else if (view() === 'ngsild-manual') {
    <lib-ngsild-home
      [resourceServer]="initialSelection()?.resourceServer ?? 'ngsi-ld'"
      [ogcOnboardingMode]="initialSelection()?.ogcOnboardingMode"
      [publisherRole]="publisherRole()"
      (back)="onNgsildBack()"
      (complete)="onNgsildComplete($event)"
      (submitError)="onNgsildSubmitError($event)"
    />
  } @else if (view() === 'json-upload') {
    <lib-metadata-json-home
      [resourceServer]="initialSelection()?.resourceServer ?? 'ngsi-ld'"
      [ogcOnboardingMode]="initialSelection()?.ogcOnboardingMode"
      [publisherRole]="publisherRole()"
      (back)="onNgsildBack()"
      (complete)="onNgsildComplete($event)"
      (submitError)="onNgsildSubmitError($event)"
    />
  }
</div>

@if (successModalVisible()) {
  <div
    class="onboarding-success-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-success-title"
    aria-describedby="onboarding-success-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
    <div class="onboarding-success-modal__panel">
      <div class="onboarding-success-modal__body">
        <h2 id="onboarding-success-title" class="onboarding-success-modal__title">
          Metadata Information is successfully stored.
        </h2>
        <p id="onboarding-success-desc" class="onboarding-success-modal__status">
          Please upload the data inorder to publish the dataset.
        </p>
        <div class="onboarding-success-modal__actions">
          <button type="button" class="onboarding-success-modal__btn onboarding-success-modal__btn--primary" (click)="onUploadNowClick()">
            Upload now
          </button>
          <span class="onboarding-success-modal__or" aria-hidden="true">or</span>
          <button type="button" class="onboarding-success-modal__btn onboarding-success-modal__btn--secondary" (click)="onUploadLaterClick()">
            Upload Later
          </button>
        </div>
      </div>
      <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
        <img [src]="leafImageSrc()" alt="" class="onboarding-success-modal__leaf-image" />
      </div>
    </div>
  </div>
}

@if (ogcUploadModalVisible()) {
  <div
    class="onboarding-upload-modal onboarding-upload-modal--ogc"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-ogc-upload-heading"
    aria-describedby="onboarding-ogc-upload-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-upload-modal__backdrop" aria-hidden="true" (click)="dismissOgcUploadModal()"></div>
    <div class="onboarding-upload-modal__panel onboarding-upload-modal__panel--stac" (click)="$event.stopPropagation()">
      <header class="onboarding-upload-modal__header">
        <div class="onboarding-upload-modal__header-text">
          <h2 id="onboarding-ogc-upload-heading" class="onboarding-upload-modal__title">Upload Files</h2>
          <p id="onboarding-ogc-upload-desc" class="onboarding-upload-modal__lede">
            Upload GeoPackage files for this dataset.
            @if (uploadModalDatasetLabel()) {
              Dataset: <strong>{{ uploadModalDatasetLabel() }}</strong>
            }
          </p>
        </div>
        <button
          type="button"
          class="onboarding-upload-modal__close"
          (click)="onOgcUploadModalPrevious()"
          aria-label="Go back to previous step"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </header>
      <div class="onboarding-upload-modal__body onboarding-upload-modal__body--stac">
        <div class="onboarding-upload-modal__panel">
          <p class="onboarding-upload-modal__panel-lede">
            Drag and drop or browse to add files. Click <strong>Publish</strong> when uploads are complete.
          </p>
        <lib-ogc-upload-files
          [loadKey]="ogcUploadLoadKey()"
          [itemId]="ngsildCreatedItemId()"
          [datasetTitle]="uploadModalDatasetLabel()"
          [datasetDescription]="ogcUploadDatasetDescription()"
          (modalDismiss)="dismissOgcUploadModal()"
          (modalPrevious)="onOgcUploadModalPrevious()"
          (publishSuccess)="onOgcUploadPublishSuccess()"
          (uploadError)="onNgsildSubmitError($event)"
        />
        </div>
      </div>
    </div>
  </div>
}

@if (stacOnboardingModalVisible()) {
  <div
    class="onboarding-upload-modal onboarding-upload-modal--stac"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-stac-heading"
    aria-describedby="onboarding-stac-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-upload-modal__backdrop" aria-hidden="true" (click)="dismissStacOnboardingModal()"></div>
    <div class="onboarding-upload-modal__panel" (click)="$event.stopPropagation()">
      <header class="onboarding-upload-modal__header">
        <div class="onboarding-upload-modal__header-text">
          <h2 id="onboarding-stac-heading" class="onboarding-upload-modal__title">
            @if (isOgcRasterUploadFlow()) {
              Upload Assets
            } @else {
              Stac Collection Onboarding
            }
          </h2>
          <p id="onboarding-stac-desc" class="onboarding-upload-modal__lede">
            @if (isOgcRasterUploadFlow()) {
              Upload raster assets for this dataset.
            } @else {
              Create a STAC collection for this raster dataset.
            }
            @if (uploadModalDatasetLabel()) {
              Dataset: <strong>{{ uploadModalDatasetLabel() }}</strong>
            }
          </p>
        </div>
        <button
          type="button"
          class="onboarding-upload-modal__close"
          (click)="onStacOnboardingModalPrevious()"
          aria-label="Go back to previous step"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </header>
      <div class="onboarding-upload-modal__body onboarding-upload-modal__body--stac">
        <lib-stac-collection-onboarding
          [flowScope]="isOgcRasterUploadFlow() ? 'assets-only' : 'full'"
          [itemId]="ngsildCreatedItemId()"
          [initialCollectionId]="stacCollectionId()"
          [initialItemId]="stacItemId()"
          [datasetTitle]="uploadModalDatasetLabel()"
          [datasetDescription]="ogcUploadDatasetDescription()"
          (modalDismiss)="dismissStacOnboardingModal(false)"
          (modalPrevious)="onStacOnboardingModalPrevious()"
          (collectionCreated)="onStacCollectionCreated()"
          (onboardingError)="onNgsildSubmitError($event)"
          (onboardingSuccess)="onStacOnboardingSuccess($event)"
        />
      </div>
    </div>
  </div>
}

@if (uploadModalVisible()) {
  <div
    class="onboarding-upload-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-upload-heading"
    aria-describedby="onboarding-upload-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-upload-modal__backdrop" aria-hidden="true" (click)="dismissUploadModal()"></div>
    <div class="onboarding-upload-modal__panel" (click)="$event.stopPropagation()">
      <header class="onboarding-upload-modal__header">
        <div class="onboarding-upload-modal__header-text">
          <h2 id="onboarding-upload-heading" class="onboarding-upload-modal__title">Connection Details</h2>
          <p id="onboarding-upload-desc" class="onboarding-upload-modal__lede">
            @switch (uploadModalConnectionDetailsLedeKind()) {
              @case ('file-server') {
                @if (uploadModalDataSourceUrlEnabled()) {
                  Upload files directly or connect a <strong>Data Source URL</strong> to fetch data automatically.
                } @else {
                  Upload files directly to add data to this dataset.
                }
              }
              @case ('gateway') {
                @if (uploadModalDataSourceUrlEnabled()) {
                  Configure <strong>SFTP</strong> or <strong>API</strong> connection details, set up
                  <strong>Direct Push</strong>, or connect a <strong>Data Source URL</strong> to fetch data automatically.
                } @else {
                  Configure <strong>SFTP</strong> or <strong>API</strong> connection details, or set up
                  <strong>Direct Push</strong>.
                }
              }
              @case ('direct-push') {
                Use the <strong>Direct Push</strong> Python script to push data to this dataset.
              }
              @default {
                @if (uploadModalDataSourceUrlEnabled()) {
                  Configure <strong>SFTP</strong> or <strong>API</strong> connection details, or connect a
                  <strong>Data Source URL</strong> to fetch data automatically.
                } @else {
                  Configure <strong>SFTP</strong> or <strong>API</strong> connection details.
                }
              }
            }
          </p>
        </div>
        <button
          type="button"
          class="onboarding-upload-modal__close"
          (click)="onUploadModalPrevious()"
          aria-label="Go back to previous step"
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M18 6L6 18M6 6L18 18"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </header>
      <div class="onboarding-upload-modal__body">
        <lib-ngsild-upload-files
          layout="modal"
          [resourceServer]="uploadModalResourceServer()"
          [fileFormat]="uploadModalFileFormat()"
          [modalDatasetLabel]="uploadModalDatasetLabel()"
          [itemId]="ngsildCreatedItemId()"
          [onboardingPayload]="ngsildLastPayload()?.payload ?? null"
          (modalDismiss)="dismissUploadModal()"
          (modalPrevious)="onUploadModalPrevious()"
          (publishSuccess)="onUploadPublishSuccess()"
          (uploadRequestSuccess)="onUploadRequestSuccess($event)"
          (directPushSuccess)="onDirectPushSuccess()"
        />
      </div>
    </div>
  </div>
}

@if (directPushSuccessModalVisible()) {
  <div
    class="onboarding-success-modal onboarding-direct-push-success-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-direct-push-success-title"
    aria-describedby="onboarding-direct-push-success-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
    <div class="onboarding-success-modal__panel">
      <div class="onboarding-success-modal__body">
        <div class="onboarding-publish-success-modal__icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#16a34a" stroke-width="2" />
            <path d="M9 12l2 2 4-4" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h2 id="onboarding-direct-push-success-title" class="onboarding-success-modal__title">
          Direct Push configured
        </h2>
        <p id="onboarding-direct-push-success-desc" class="onboarding-publish-success-modal__message">
          No files have been uploaded yet. Use the Python script in Connection Details to push files to your dataset when you are ready.
        </p>
        <div class="onboarding-success-modal__actions">
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--primary"
            (click)="onDirectPushCreateNew()"
          >
            OK
          </button>
        </div>
      </div>
      <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
        <img [src]="leafImageSrc()" alt="" class="onboarding-success-modal__leaf-image" />
      </div>
    </div>
  </div>
}

@if (uploadRequestSuccessModalVisible()) {
  <div
    class="onboarding-success-modal onboarding-upload-request-success-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-upload-request-success-title"
    aria-describedby="onboarding-upload-request-success-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
    <div class="onboarding-success-modal__panel">
      <div class="onboarding-success-modal__body">
        <div class="onboarding-publish-success-modal__icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#16a34a" stroke-width="2" />
            <path d="M9 12l2 2 4-4" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h2 id="onboarding-upload-request-success-title" class="onboarding-success-modal__title">
          {{ uploadRequestSuccessTitle() }}
        </h2>
        <p id="onboarding-upload-request-success-desc" class="onboarding-publish-success-modal__message">
          {{ uploadRequestSuccessMessage() }}
        </p>
        <div class="onboarding-upload-request-success-modal__next-steps">
          <p class="onboarding-upload-request-success-modal__next-steps-title">What happens next?</p>
          <p class="onboarding-upload-request-success-modal__next-steps-body">
            {{ uploadRequestNextStepsMessage() }}
          </p>
        </div>
        <div class="onboarding-success-modal__actions onboarding-success-modal__actions--row">
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--secondary"
            (click)="onUploadRequestCreateNew()"
          >
            Create New
          </button>
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--primary"
            [disabled]="!ngsildCreatedItemId()"
            (click)="onUploadRequestViewDataset()"
          >
            View Dataset
          </button>
        </div>
      </div>
      <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
        <img [src]="leafImageSrc()" alt="" class="onboarding-success-modal__leaf-image" />
      </div>
    </div>
  </div>
}

@if (publishSuccessModalVisible()) {
  <div
    class="onboarding-success-modal onboarding-publish-success-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="onboarding-publish-success-title"
    aria-describedby="onboarding-publish-success-desc"
    (keydown)="$event.stopPropagation()"
  >
    <div class="onboarding-success-modal__backdrop" aria-hidden="true"></div>
    <div class="onboarding-success-modal__panel">
      <div class="onboarding-success-modal__body">
        <div class="onboarding-publish-success-modal__icon" aria-hidden="true">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#16a34a" stroke-width="2" />
            <path d="M9 12l2 2 4-4" stroke="#16a34a" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <h2 id="onboarding-publish-success-title" class="onboarding-success-modal__title">
          {{ publishSuccessTitle() }}
        </h2>
        <p id="onboarding-publish-success-desc" class="onboarding-publish-success-modal__message">
          {{ publishSuccessMessage() }}
        </p>
        <div class="onboarding-success-modal__actions onboarding-success-modal__actions--row">
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--secondary"
            (click)="onPublishCreateNew()"
          >
            Create New
          </button>
          <button
            type="button"
            class="onboarding-success-modal__btn onboarding-success-modal__btn--primary"
            [disabled]="!ngsildCreatedItemId()"
            (click)="onPublishViewDataset()"
          >
            View Dataset
          </button>
        </div>
      </div>
      <div class="onboarding-success-modal__leaf-pattern" aria-hidden="true">
        <img [src]="leafImageSrc()" alt="" class="onboarding-success-modal__leaf-image" />
      </div>
    </div>
  </div>
}
